import React from 'react';

import { useFieldContext, FieldErrors } from '..';
import { Checkbox, Label } from '../../Elements';

export const sizes = {
	lg: 'w-[24px] h-[24px] rounded',
	sm: '',
};

type CheckboxFieldProps = {
	className?: string;
	labelClassName?: string;
	boxSize?: keyof typeof sizes;
	label: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const CheckboxFieldV2 = ({
	label,
	boxSize,
	labelClassName,
	...inputProps
}: CheckboxFieldProps) => {
	const field = useFieldContext<string>();

	// hide the error messages until the field has been touched
	const hideErrors = !field.state.meta.isTouched;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<Checkbox
				name={field.name}
				id={field.name}
				className={sizes[boxSize || 'sm']}
				value='true'
				handleChange={field.handleChange}
				aria-invalid={hasErrors ? 'true' : 'false'}
				aria-errormessage={hasErrors ? `${field.name}-error` : ''}
				checked={field.state.value === 'true'}
				{...inputProps}
			/>
			<Label
				htmlFor={field.name}
				label={label}
				className={labelClassName || 'mb-2 !inline-block'}
			/>
			<FieldErrors name={field.name} meta={field.state.meta} hideErrors={hideErrors} />
		</>
	);
};
